import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ThunkDispatch } from "redux-thunk";
import { logout } from "store/actions/authActions";
import { loadCompaniesAsync } from "store/actions/authActions";
import CompanySelection from "./companySelection";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { loadProfileLanguageAsync } from "store/actions/commonActions";

const SelectCompany: React.FC = () => {
  const navigate = useNavigate();
  const { "*": path } = useParams();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [companies, setCompanies] = React.useState<WintSuperkollAPIModel.Company[] | undefined>();

  React.useEffect(() => {
    dispatch(loadCompaniesAsync() as unknown as Promise<WintSuperkollAPIModel.Company[]>).then((result) => {
      setCompanies(result);
      if (result.length === 1) {
        navigate(`/${result[0].url}/${path}`, { replace: true });
      }
    });
    dispatch(loadProfileLanguageAsync());
  }, []);

  const onLogoutClick = () => {
    dispatch(logout());
    navigate("/Login", { replace: true });
  };

  return (
    <CompanySelection
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.SelectCompany)}
      explanation={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.SelectCompanyDescription)}
      companies={companies ? companies.map((c) => ({ id: c.id, name: c.name ?? "", url: `/${c.url}/${path}` })) : []}
      logOut={onLogoutClick}
    />
  );
};

export default SelectCompany;
